import { render, staticRenderFns } from "./AdminBaseCampains.vue?vue&type=template&id=248e3e78"
import script from "./AdminBaseCampains.vue?vue&type=script&lang=js"
export * from "./AdminBaseCampains.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports